import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RoomMessage } from 'src/app/data/models/interfaces/room-message.interface';
import { ChatForwardRoomComponent } from '../chat-forward-room/chat-forward-room.component';
import { RoomsService } from 'src/app/data/services/rooms.service';
import { CreateFowardMessage } from 'src/app/data/models/interfaces/create-foward-message';
import { Room } from 'src/app/data/models/interfaces/room.interface';
import { RoomsMessagesService } from 'src/app/data/services/rooms-messages.service';
import { EventQueueService } from 'src/app/data/services/event-queue.service';
import { AppEvent } from 'src/app/data/models/app-event';
import { AppEventType } from 'src/app/data/models/enum/app-event-type.enum';
import { ChatsGatewayService } from 'src/app/data/services/chats-gateway.service';

@Component({
  selector: 'app-chat-forward-message',
  templateUrl: './chat-forward-message.component.html',
  styleUrls: ['./chat-forward-message.component.scss'],
})
export class ChatForwardMessageComponent implements OnInit {
  @Output() onComplete = new EventEmitter<boolean>();

  @Input() forwardMessages: RoomMessage[] = [];
  @Input() idChannel!: string;

  constructor(
    public dialog: MatDialog,
    private roomService: RoomsService,
    private roomsMessagesService: RoomsMessagesService,
    private eventQueue: EventQueueService,
    private chatsGatewayService: ChatsGatewayService
  ) {}

  messageMapping: { [k: string]: string } = {
    '=0': 'Nenhuma mensagem selecionada',
    '=1': '1 mensagem selecionada',
    other: '# mensagens selecionadas',
  };

  ngOnInit(): void {}

  cancel() {
    this.onComplete.emit(false);
  }

  async selectChannel() {
    const idUser = this.forwardMessages[0].idAuthor;
    const rooms = await this.roomService.getAll(idUser).toPromise();
    const dialogRef = this.dialog.open(ChatForwardRoomComponent, {
      data: { rooms },
    });
    dialogRef
      .afterClosed()
      .toPromise()
      .then((res) => {
        if (res !== '' && res) {
          this.forward(res as Room);
        }
      });
  }

  private async forward(room: Room) {
    // call api
    for (const msg of this.forwardMessages) {
      if (msg.id && room.idChannel) {
        const createForwardMessage: CreateFowardMessage = {
          id: msg.id,
          toRoomId: room.id,
          fromChannelId: this.idChannel,
          toChannelId: room.idChannel,
        };
        const roomMessageDto = await this.roomsMessagesService
          .fowardMessage(createForwardMessage)
          .toPromise();

        if (roomMessageDto.foward) {
          this.chatsGatewayService.sendRoomMessageV2(roomMessageDto);
          this.chatsGatewayService.sendForwardMessage({
            idRoom: msg.idRoom,
            foward: roomMessageDto.foward,
          });
          msg.foward = roomMessageDto.foward;
          //to internal update
          this.eventQueue.dispatch(
            new AppEvent(AppEventType.FORWARD_MESSAGE_TO_ROOM, roomMessageDto)
          );
        }
      }
    }
    this.eventQueue.dispatch(new AppEvent(AppEventType.FORWARD_TO_ROOM, room));

    //when success
    this.onComplete.emit(true);
  }
}
